export default __webpack_public_path__ + "static/media/outline-group-24-px-1.5f54ce2b.svg";